var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-mode-container px-3 pb-3 pt-1"},_vm._l((_vm.data),function(item,index){return _c('FormModeItem',{key:index,attrs:{"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }